import { render, staticRenderFns } from "./VenueMetrics.vue?vue&type=template&id=6878b75e&scoped=true"
import script from "./VenueMetrics.vue?vue&type=script&lang=js"
export * from "./VenueMetrics.vue?vue&type=script&lang=js"
import style0 from "./VenueMetrics.vue?vue&type=style&index=0&id=6878b75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6878b75e",
  null
  
)

export default component.exports